module.exports = __webpack_public_path__ + "img/sleeve placket width.db7ef08a.png";